import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=773a16a4&scoped=true"
import script from "./OrderDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDrawer.vue?vue&type=style&index=0&id=773a16a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a16a4",
  null
  
)

export default component.exports